import React from 'react';
import Layout from '../../components/UI/Layout/Layout'
import List from '../../components/Entity/Tasks/List/List';

const TasksPage = () => {
  return <Layout fullwidth={0}>
      <List></List> 
  </Layout>;
}

export default TasksPage;
